/**
 * Range preset utilities
 */

/**
 * Get date range for a preset
 * Returns exact date bounds for the period (no padding - that's added by calculateDateRange)
 */
export function getPresetDateRange(presetId) {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  switch (presetId) {
    case 'today': {
      const start = new Date(today);
      const end = new Date(today);
      end.setDate(end.getDate() + 1);
      return { startDate: start, endDate: end, suggestedZoom: 'hour' };
    }
    case 'this-week': {
      // Start of week (Monday) - getDay() returns 0 for Sunday, 1 for Monday, etc.
      const dayOfWeek = today.getDay();
      const daysFromMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Sunday = 6 days back, otherwise day - 1
      const start = new Date(today);
      start.setDate(start.getDate() - daysFromMonday);
      const end = new Date(start);
      end.setDate(end.getDate() + 7); // Full 7 days (Mon-Sun)
      return { startDate: start, endDate: end, suggestedZoom: 'day-detail' };
    }
    case 'this-month': {
      // First day of current month to first day of next month
      const start = new Date(today.getFullYear(), today.getMonth(), 1);
      const end = new Date(today.getFullYear(), today.getMonth() + 1, 1);
      return { startDate: start, endDate: end, suggestedZoom: 'day' };
    }
    case 'this-quarter': {
      const quarterStart = Math.floor(today.getMonth() / 3) * 3;
      const start = new Date(today.getFullYear(), quarterStart, 1);
      const end = new Date(today.getFullYear(), quarterStart + 3, 1);
      return { startDate: start, endDate: end, suggestedZoom: 'week' };
    }
    case 'this-year': {
      const start = new Date(today.getFullYear(), 0, 1); // Jan 1
      const end = new Date(today.getFullYear() + 1, 0, 1); // Jan 1 next year
      return { startDate: start, endDate: end, suggestedZoom: 'month' };
    }
    default:
      return null; // 'all' returns null to use task-based range
  }
}
